$(document).ready(function () {
      var $header = $("header.headroom");
      var search = $("#search-container");
      var $form = $("#search-container form");
      var btn = $(".search-button");
      var textBox = $("#search-container form .input-search");

      $("body").click(function (e) {
         if (!$(e.target).closest(btn).length
            && !$(e.target).closest(search).length
            && $(search).hasClass("expanded") ) {
            closeSearch();
         }
      });

      $(btn).click(function (e) {
         e.preventDefault();
         if ($(search).hasClass("expanded")) {
            closeSearch();
         }
         else {
            expandSearch();
         }
      })

      function expandSearch() {
         $(btn).find(".search").css("display", "none");
         $(btn).find(".close").css("display", "block");
         $(search).addClass("expanded");
         $(textBox).focus();
      }

      function closeSearch() {
         $(search).removeClass("expanded");
         $(btn).find(".search").css("display", "block");
         $(btn).find(".close").css("display", "none");
      }
   });


// WEBPACK FOOTER //
// ./js/header.js